import SignDocuments from './SignDocuments';

const Novuna = {
  SignDocuments,
};

export default Novuna;
